<script>
import FacilityProjectCoverSheet from "@/modules/projects/components/FacilityProjectCoverSheet.vue";

export default {
  name: "FacilityProjectLinks",
  components: {FacilityProjectCoverSheet},

  props: {
    project: {
      type: Object,
      reqiured: true
    }
  },

  methods: {
    copyProjectInfoToClipboard: function (project) {
      window.prompt(
          "CTRL+C to copy then Enter",
          project.projectNo + " " + project.name
      );
    }
  }
}
</script>

<template>
  <v-list dense tyle="padding-top: 0px !important;" flat>
    <v-subheader>{{ project.projectNo }} {{ project.name }}</v-subheader>
    <v-list-item
        :href="`https://dms.ipf.msu.edu/BCEnterprise/?VIEWID=DOC_06D66&DOCFILTER=2c5745&RECORD_ID=${project.projectId}`"
    >
      <v-list-item-icon>
        <v-icon dense>mdi-folder-open</v-icon>
      </v-list-item-icon>
      <v-list-item-title>files</v-list-item-title>
    </v-list-item>

    <facility-project-cover-sheet
        :project-id="project.projectId"
    ></facility-project-cover-sheet>

    <v-list-item @click="copyProjectInfoToClipboard(project)">
      <v-list-item-icon>
        <v-icon dense>mdi-clipboard-arrow-down-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Copy</v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<style scoped>
.v-list-item__icon {
  height: 24px;
  margin: 0px !important;
  margin-right: .5em !important;
}

.v-list--dense .v-list-item, .v-list-item--dense {
  min-height: 20px;
  height: 24px;
}

.v-list-item__title {
  font-weight: 400 !important;
}
</style>
